<template>
  <el-card class="contact-card" shadow="never">
    <div slot="header" class="card-header">
      <span class="card-title">联系人</span>
      <el-button type="primary" size="small" icon="el-icon-plus" @click="openAddModal">添加联系人</el-button>
    </div>

    <div v-if="contactList.length > 0" class="contact-list">
      <div v-for="(item, index) in contactList" :key="item.id || index" class="contact-item">
        <div class="contact-main">
          <div class="contact-avatar">{{ item.contactName ? item.contactName.charAt(0) : '?' }}</div>
          <div class="contact-info">
            <div class="contact-name-row">
              <span class="contact-name">{{ item.contactName }}</span>
              <el-tag v-if="item.gender == 1" size="mini" effect="plain">男</el-tag>
              <el-tag v-if="item.gender == 2" size="mini" effect="plain">女</el-tag>
            </div>
            <div class="contact-position">{{ item.departmentName || item.departmentId || '' }} {{ item.position }}</div>
          </div>
        </div>
        <div class="contact-detail">
          <div class="detail-row">
            <span class="detail-label">手机</span>
            <span class="detail-value">{{ item.mobile || '—' }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">电话</span>
            <span class="detail-value">{{ item.phone || '—' }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">微信</span>
            <span class="detail-value">{{ item.wechat || '—' }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">QQ</span>
            <span class="detail-value">{{ item.qq || '—' }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">邮箱</span>
            <span class="detail-value">{{ item.email || '—' }}</span>
          </div>
        </div>
        <div class="contact-actions">
          <span v-if="item.updateTime" class="update-time">更新于 {{ item.updateTime }}</span>
          <el-button type="text" size="mini" icon="el-icon-edit" @click="editContact(item)">修改</el-button>
          <el-button type="text" size="mini" icon="el-icon-delete" style="color: #f56c6c" @click="deleteContact(item)">删除</el-button>
        </div>
      </div>
    </div>

    <el-empty v-else description="暂无联系人" />

    <!-- 弹窗：添加/修改联系人 -->
    <el-dialog :title="contactFormIndex !== null ? '修改联系人' : '添加联系人'" :visible.sync="showAddContact" width="520px" :close-on-click-modal="false">
      <el-form ref="contactForm" :model="contactForm" :rules="contactRules" label-width="70px" size="small">
        <el-row :gutter="16">
          <el-col :span="12"><el-form-item label="姓名" prop="contactName"><el-input v-model="contactForm.contactName" placeholder="请输入姓名" /></el-form-item></el-col>
          <el-col :span="12">
            <el-form-item label="性别" prop="gender">
              <el-select v-model="contactForm.gender" placeholder="请选择" style="width: 100%">
                <el-option label="男" :value="1" />
                <el-option label="女" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12"><el-form-item label="部门" prop="departmentName"><el-input v-model="contactForm.departmentName" placeholder="请输入部门" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="职位" prop="position"><el-input v-model="contactForm.position" placeholder="请输入职位" /></el-form-item></el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12"><el-form-item label="手机" prop="mobile"><el-input v-model="contactForm.mobile" placeholder="请输入手机号" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="电话" prop="phone"><el-input v-model="contactForm.phone" placeholder="请输入电话" /></el-form-item></el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12"><el-form-item label="微信" prop="wechat"><el-input v-model="contactForm.wechat" placeholder="请输入微信号" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="QQ" prop="qq"><el-input v-model="contactForm.qq" placeholder="请输入QQ号" /></el-form-item></el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12"><el-form-item label="邮箱" prop="email"><el-input v-model="contactForm.email" placeholder="请输入邮箱" /></el-form-item></el-col>
        </el-row>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="contactForm.remark" type="textarea" :rows="2" placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="showAddContact = false">取消</el-button>
        <el-button type="primary" size="small" :loading="submitting" @click="submitContact">确定</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
export default {
  name: 'ContactListCard',
  props: {
    // 项目id（添加联系人时提交参数用），由父组件传入
    projectId: { type: [Number, String], default: 0 },
    // 联系人列表，由父组件请求 project/Detail 后传入
    contactList: { type: Array, default: () => [] }
  },
  data() {
    return {
      submitting: false,
      showAddContact: false,
      contactForm: { contactName: '', gender: '', departmentName: '', position: '', mobile: '', phone: '', wechat: '', qq: '', email: '', remark: '' },
      contactFormIndex: null, // null=添加，否则为编辑的联系人id
      contactRules: {
        contactName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        mobile: [{ pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }],
        email: [{ type: 'email', message: '邮箱格式不正确', trigger: 'blur' }]
      }
    }
  },
  computed: {
    // 后台接口命名空间，若与你项目里 $api 的配置不一致，只改这里即可
    contactApi() {
      return this.$api.common.projectContact
    }
  },
  // 弹窗关闭时重置表单
  watch: {
    showAddContact(val) { if (!val) this.resetContactForm() }
  },
  methods: {
    // 联系人详情（编辑回显）
    getDetail(contactId) {
      let ajaxUrl = this.contactApi.detail()
      this.$axios.get(ajaxUrl, { params: { contactId: contactId } }).then((res) => {
        if (res.success) {
          this.contactForm = {
            contactName: res.data.contactName || '',
            gender: res.data.gender || '',
            departmentName: res.data.departmentName || res.data.departmentId || '',
            position: res.data.position || '',
            mobile: res.data.mobile || '',
            phone: res.data.phone || '',
            wechat: res.data.wechat || '',
            qq: res.data.qq || '',
            email: res.data.email || '',
            remark: res.data.remark || ''
          }
          this.showAddContact = true
        } else {
          this.$message.error(res.msg)
        }
      }).catch((err) => {
        console.error('getDetail err:', err)
      })
    },

    // 添加、更新联系人（contactId=0 新增，大于0 更新；成功后通知父组件刷新）
    saveContact() {
      let ajaxUrl = this.contactApi.post()
      this.submitting = true
      const params = {
        contactId: this.contactFormIndex !== null ? this.contactFormIndex : 0,
        projectId: this.projectId,
        contactName: this.contactForm.contactName
      }
      if (this.contactForm.gender !== '') params.gender = this.contactForm.gender
      if (this.contactForm.departmentName) params.departmentName = this.contactForm.departmentName
      if (this.contactForm.position) params.position = this.contactForm.position
      if (this.contactForm.mobile) params.mobile = this.contactForm.mobile
      if (this.contactForm.phone) params.phone = this.contactForm.phone
      if (this.contactForm.wechat) params.wechat = this.contactForm.wechat
      if (this.contactForm.qq) params.qq = this.contactForm.qq
      if (this.contactForm.email) params.email = this.contactForm.email
      if (this.contactForm.remark) params.remark = this.contactForm.remark

      // 后台要求 POST 走 $.ajax
      $.ajax({
        url: ajaxUrl,
        type: 'POST',
        data: params,
        success: (res) => {
          this.submitting = false
          if (res.success) {
            this.$message({ type: 'success', message: '保存成功' })
            this.showAddContact = false
            this.$emit('refresh')
          } else {
            this.$message.error(res.msg)
          }
        },
        error: (err) => {
          this.submitting = false
          console.error('saveContact err:', err)
        }
      })
    },

    // 删除联系人（成功后通知父组件刷新）
    deleteContact(item) {
      this.$confirm('确认删除该联系人？', '提示', { type: 'warning' }).then(() => {
        let ajaxUrl = this.contactApi.delete()
        // 后台要求 POST 走 $.ajax
        $.ajax({
          url: ajaxUrl,
          type: 'POST',
          data: { contactId: item.id },
          success: (res) => {
            if (res.success) {
              this.$message({ type: 'success', message: '删除成功' })
              this.$emit('refresh')
            } else {
              this.$message.error(res.msg)
            }
          },
          error: (err) => {
            console.error('deleteContact err:', err)
          }
        })
      }).catch(() => {})
    },

    // ==================== 交互 ====================
    editContact(item) {
      this.contactFormIndex = item.id
      this.getDetail(item.id)
    },
    submitContact() {
      this.$refs.contactForm.validate(valid => {
        if (!valid) return
        this.saveContact()
      })
    },
    openAddModal() {
      this.contactFormIndex = null
      this.showAddContact = true
    },
    resetContactForm() {
      this.contactForm = { contactName: '', gender: '', departmentName: '', position: '', mobile: '', phone: '', wechat: '', qq: '', email: '', remark: '' }
      this.contactFormIndex = null
      if (this.$refs.contactForm) this.$refs.contactForm.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}
.contact-card {
  ::v-deep .el-card__body {
    padding: 16px;
  }
}
.contact-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.contact-item {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 14px;
  transition: all 0.2s;
  &:hover {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
    border-color: #d9ecff;
  }
}
.contact-main {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.contact-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: linear-gradient(135deg, #409eff, #1a73e8);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  flex-shrink: 0;
}
.contact-info {
  flex: 1;
  min-width: 0;
}
.contact-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}
.contact-name {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}
.contact-position {
  font-size: 12px;
  color: #909399;
}
.contact-detail {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 16px;
  margin-bottom: 10px;
}
.detail-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}
.detail-label {
  color: #909399;
  width: 32px;
  flex-shrink: 0;
}
.detail-value {
  color: #606266;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.contact-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  .update-time {
    margin-right: auto;
    font-size: 12px;
    color: #c0c4cc;
  }
  padding-top: 8px;
  border-top: 1px dashed #ebeef5;
}
</style>